import { render, staticRenderFns } from "./BrandFilterContent.vue?vue&type=template&id=20423514&"
import script from "./BrandFilterContent.vue?vue&type=script&lang=js&"
export * from "./BrandFilterContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports